import React, { useMemo } from "react";
import Image from "next/image";
import Link from "next/link";
import { COMPLIANCE } from "@/app/get-started-v3/constants";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const footerLinks = [
  {
    title: "Terms",
    url: COMPLIANCE.TERMS_AND_CONDITION,
  },
  {
    title: "Privacy Policy",
    url: "/privacy-policy",
  },
  {
    title: "Complaints",
    url: "/complaints",
  },
  {
    title: "FAQs",
    url: "/faqs",
  },
];

const Footer = () => {
  const screens = useBreakpoint();
  const logoComp = useMemo(() => {
    return (
      <Image
        src={"/fair-white.svg"}
        alt="Fair"
        width={65}
        height={26}
        className="w-[65px] h-[26px] md:w-[125px] md:h-[50px]"
      />
    );
  }, []);

  return (
    <div className="bg-secondary-2 text-white py-5 flex items-center flex-col px-3 text-sm">
      <div className="max-w-[1400px] flex items-center w-full justify-between flex-col md:flex-row gap-3">
        <div>{logoComp}</div>
        <div className="bg-white w-[1px] h-[70px] hidden md:block"></div>
        <div
          style={{
            textAlign: screens.xs ? "center" : "left",
            fontSize: screens.xs ? "8px" : "14px",
          }}
        >
          You can claim for free, without using a CMC first to your finance
          provider or to the FOS/FSCS. Fair is a trading style of Reclaims 4 U
          Ltd. Reclaims 4 U Ltd is authorised and regulated by the Financial
          Conduct Authority with reference number FRN 830181. Reclaims 4 U Ltd
          is a Claims Management Company (CMC). Registered in England and Wales,
          Company number 6651869. Registered with the Information Commissioner's
          Office: registration number Z1480043. Registered Address: Unit 1.02b,
          Boatshed, Office Village, 12 Exchange Quay, Salford, M5 3EQ. VAT
          Number: 989401772
        </div>
      </div>

      <div className="max-w-[1500px] flex items-center justify-between mt-5 w-full">
        {footerLinks?.map((link, index) => (
          <Link
            key={index}
            className="link-unset"
            href={link.url}
            target="_blank"
          >
            {link.title}
          </Link>
        ))}
      </div>

      <div className="bg-primary-dark w-full h-1 my-5 max-w-[1700px]"></div>
      <div>Copyright © {new Date().getFullYear()}. All rights reserved.</div>
    </div>
  );
};

export default Footer;
